import { useEtsyCircuitBreakerStore } from '@/helpers/etsy-circuit-breaker';
export default {
  path: '/rank-checker',
  name: 'rank-checker',
  component: () => import('@/modules/rank-checker/pages/Entry.vue'),
  meta: {
    requiresAuth: true,
    metaTags: [
      {
        content: 'Track where listings appear in Etsy search results without personalization or ads.',
        name: 'description',
      },
      {
        name: "google",
        content: "notranslate",
      },
      {
        page_slug: 'rank-checker',
      },
    ],
    title: 'eRank — Rank Checker',
  },
  beforeEnter: async () => {
    const etsyCircuitBreakerStore = useEtsyCircuitBreakerStore();
    const response = await etsyCircuitBreakerStore.requestStatus();
    etsyCircuitBreakerStore.setActions(response.data);
    return true;
  },
};
